export default "<div class=\"mb-48 auto-height\">\n    <div class=\"flowplayer\">\n    </div>\n</div>";